// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function userDelete() {
  return http<unknown>({
    url: "/api/v1/user/",
    method: "delete",
  })
}
